export const c_drawer__panel_md_FlexBasis_max = {
  "name": "--pf-v6-c-drawer__panel--md--FlexBasis--max",
  "value": "100%",
  "var": "var(--pf-v6-c-drawer__panel--md--FlexBasis--max)"
};
export default c_drawer__panel_md_FlexBasis_max;